/**
 * The devstack Jira instance the annotation tickets are filed in. One instance
 * serves every environment, so unlike the PMTiles hosts this is not keyed by
 * `Environment`.
 */
const JIRA_BASE_URL = 'https://devstack.vwgroup.com/jira'

/** The browse URL for a Jira issue key such as `MAT-1234`. */
export const jiraIssueUrl = (issueKey: string): string =>
  `${JIRA_BASE_URL}/browse/${encodeURIComponent(issueKey)}`
